import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SITE_LINKS } from '@shared/constants/site-links.constants';
import { STORAGE } from '@shared/constants/storage.constants';
import { StorageService } from '@shared/services/storage/storage.service';
import { sanitizeReturnUrl } from '@shared/utilities/auth-return-url.util';

export const authGuard: CanActivateFn = (route, state) => {
  const storageService = inject(StorageService);
  const router = inject(Router);
  if (!storageService.get(STORAGE.ACCESS_TOKEN)) {
    const returnUrl = sanitizeReturnUrl(state.url);
    router.navigate([SITE_LINKS.AUTH.LOGIN], {
      queryParams: returnUrl ? { returnUrl } : undefined,
    });
    return false;
  }
  return true;
};
